export default "__VITE_ASSET__DBLp2T0s__"